import { graphql } from '@teachino/shared-infrastructure';
import { topicListItemFragment } from '../folders/topic-list-item';

export const filterTopicsQuery = graphql(
  `
    query topics($topicFilterInput: TopicFilterInput) {
      libraryMeta {
        totalTopicsCount
      }
      topics(topicFilterInput: $topicFilterInput) {
        ...TopicListItem
      }
    }
  `,
  [topicListItemFragment],
);
